<template>
  <nav
    id="navbar"
    class="navbar deepify-dark-bg fixed-top flex-md-nowrap p-0 shadow"
  >
    <div class="navbar-brand d-flex align-items-center col-sm-3 col-md-3 col-lg-2 mr-0">
      <div
        class="d-inline-block cursor-pointer p-1"
        @click="$router.push('/')"
      >
        <DeepifyLogo
          :width="100"
          color="#f1f1f1"
          class="ml-2 cursor-pointer"
        />
      </div>
    </div>
    <ul
      v-if="$route.meta.requiresAuth && user"
      class="navbar-nav flex-row align-items-center px-3"
    >
      <li class="nav-item">
        <span class="header-text">
          <b>{{ user.company.name.toUpperCase() }}</b> &nbsp;/&nbsp; {{ user.full_name }}
        </span>
      </li>
      <li class="nav-item text-nowrap">
        <b-dropdown
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
        >
          <template slot="button-content">
            <img
              src="https://dummyimage.com/30/fff/fff"
              class="rounded-circle"
              alt="User"
            >
          </template>
          <b-dropdown-item>Profile</b-dropdown-item>
          <b-dropdown-item @click="signOut">
            Sign out
          </b-dropdown-item>
        </b-dropdown>
      </li>
    </ul>
  </nav>
</template>
<script>
import { mapGetters } from 'vuex';
import DeepifyLogo from '@/components/icons/Logo.vue';

export default {
  components: {
    DeepifyLogo,
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    signOut() {
      this.$ls.remove('token');
      this.$ls.remove('user');
      this.$router.go('/');
    },
  },
};
</script>
<style>
.navbar-brand {
  padding-top: .60rem!important;
  padding-bottom: .60rem!important;
  font-size: 1rem;
}

.navbar .form-control {
  padding: .75rem 1rem;
  border-width: 0;
  border-radius: 0;
}

.header-text {
  font-size: 13px;
}
</style>
